var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 3L15 5.66667V14.3333C15 14.5101 14.9315 14.6797 14.8096 14.8047C14.6877 14.9298 14.5224 15 14.35 15H2.65C2.47761 15 2.31228 14.9298 2.19038 14.8047C2.06848 14.6797 2 14.5101 2 14.3333V5.66933L3.3 3H13.7ZM13.7 7H3.3V13.6667H13.7V7ZM8.5 7.66667L11.1 10.3333H9.15V13H7.85V10.3333H5.9L8.5 7.66667ZM12.8966 4.33333H4.1034L3.45405 5.66667H13.5466L12.8966 4.33333Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/Unarchive.6fbc2abb5a45c159fedee99f2e5deac7.svg";
export { ForwardRef as ReactComponent };